import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

import StarsNavigation, { Variant } from '@swf/components/StarsNavigation/StarsNavigation';
import StarsNavigationItem from '@swf/components/StarsNavigation/StarsNavigationItem';
import Translation from '@swf/components/Translation/Translation';
import type { RoutingKey } from '@swf/core/enums';
import { select } from '@swf/core/store';
import type { NavLink } from '@swf/core/types/Poker';
import { generatePath } from '@swf/core/utils/paths';

import styles from './MainNav.scss';

export interface NavItem extends NavLink {
  active?: boolean;
  route?: RoutingKey;
  values?: { [key: string]: string };
}

export interface Props {
  active?: boolean;
  links?: NavItem[];
  className?: string;
  innerClassName?: string;
  navItemClassName?: string;
}

const MainNav = ({ links, className, innerClassName, navItemClassName }: Props) => {
  const { pathname } = useLocation();
  const { routes } = useSelector(select.page.getMeta);

  if (!links || !links.length) return null;

  return (
    <StarsNavigation
      className={classNames(styles.container, className)}
      innerClassName={classNames(styles.innerContainer, innerClassName)}
      variant={Variant.Dark}
    >
      {links.map(({ active, translation, route, values = {} }) => (
        <StarsNavigationItem
          className={classNames(styles.navItem, navItemClassName)}
          route={route}
          values={values}
          key={translation.id}
          isActive={() =>
            active ?? pathname.includes(generatePath(routes?.[route ?? ''] ?? '', values))
          }
        >
          <Translation {...translation} />
        </StarsNavigationItem>
      ))}
    </StarsNavigation>
  );
};

export default MainNav;
